import { render, staticRenderFns } from "./TheSignatureTemplates.vue?vue&type=template&id=cda42e08&scoped=true&"
import script from "./TheSignatureTemplates.vue?vue&type=script&lang=js&"
export * from "./TheSignatureTemplates.vue?vue&type=script&lang=js&"
import style0 from "./TheSignatureTemplates.vue?vue&type=style&index=0&id=cda42e08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cda42e08",
  null
  
)

export default component.exports